import "@/polyfills"

import { createApp } from "vue"

import "@/assets/index.css"

import App from "@/App.web.vue"
import datadog from "@/plugins/datadog/datadog.ts"
import routerFactory from "@/plugins/router"
import routesDefinition from "@/plugins/router/routes.web"
import AssetLoadFailureService from "@/services/AssetLoadFailureService.ts"
import { CookieConsentService } from "@/services/shared/cookieConsent/CookieConsentPlugin"
import { VueQueryPlugin } from "@tanstack/vue-query"

;(async () => {
  if (
    !("Cypress" in window) &&
    (__APP_IS_VERCEL_PREVIEW__ || import.meta.env.DEV)
  ) {
    const { HeaderInjector } = await import("@soenergy/header-injector")
    HeaderInjector.init({
      appendToEl: "#app-header",
      scopeKey: __APP_VERCEL_BRANCH__ || "local",
      defaultHeaderValue: import.meta.env.VITE_X_BRANCH_NAME,
      apiUrls: [import.meta.env.VITE_API_GATEWAY_2_URL],
    })
  }

  CookieConsentService.init()

  const app = createApp(App)

  app.provide("isStaging", __APP_IS_STAGING__)
  app.use(VueQueryPlugin)
  app.use(routerFactory(routesDefinition))
  app.use(datadog, {
    version: __APP_GIT_COMMIT_SHA__,
    envResolver: () => {
      if (__APP_VERCEL_BRANCH__ === "main") {
        return __APP_IS_STAGING__ ? "staging" : "production"
      }
      return __APP_VERCEL_BRANCH__
    },
  })
  app.mount("#app")
  AssetLoadFailureService.reportIfPresent()
})()
